import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import contentService from '../services/contentService';
import { ARTICLES_LIMIT, SIDEBAR_ARTICLES_CATEGORIES } from './constants';

export default function useArticles(menuName, initialCount = ARTICLES_LIMIT) {
  const [articles, setArticles] = useState([]);
  const [startPage, setStartPage] = useState(0);
  const { i18n } = useTranslation();

  const getRequestParams = (start) => {
    return {
      sort: 'publishAt:desc',
      'filters[type][$eq]':
        menuName === SIDEBAR_ARTICLES_CATEGORIES.OFFERS ? 'offer' : 'article',
      'filters[menu][$eq]':
        menuName === SIDEBAR_ARTICLES_CATEGORIES.OFFERS ? undefined : menuName,
      'pagination[start]': start,
      'pagination[limit]': initialCount,
      'populate[main_image]': true,
    };
  };

  const fetchArticles = async () => {
    const start = startPage * initialCount;
    setStartPage(startPage + 1);
    const params = getRequestParams(start);
    const response = await contentService.getContents(params, i18n.language);
    const fetchedArticles = response.data;
    setArticles((prevArticles) => [...prevArticles, ...fetchedArticles]);
  };

  useEffect(() => {
    fetchArticles();
  }, []);

  useEffect(() => {
    const onLanguageChanged = async () => {
      const start = 0;
      setStartPage(1);
      const params = getRequestParams(start);
      const response = await contentService.getContents(params, i18n.language);
      const fetchedArticles = response.data;
      setArticles(fetchedArticles);
    };

    i18n.on('languageChanged', onLanguageChanged);

    return () => {
      i18n.off('languageChanged', onLanguageChanged);
    };
  }, [i18n]);

  return {
    articles,
    fetchArticles,
  };
}
